module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "custome-plan"
  }, [_c('el-dialog', {
    attrs: {
      "title": "选择访客计划",
      "visible": _vm.dialogVisible,
      "modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [(_vm.listData.length) ? _c('ul', {
    staticClass: "item-list"
  }, _vm._l((_vm.listData), function(item) {
    return _c('li', {
      staticClass: "item",
      class: {
        checked: _vm.selectVisitPlanValue && _vm.selectVisitPlanValue.id === item.id
      },
      on: {
        "click": function($event) {
          _vm.handleCheck(item)
        }
      }
    }, [_c('div', {
      staticClass: "time"
    }, [_vm._v(_vm._s(item.communicateTime))]), _vm._v(" "), _c('dl', {
      staticClass: "desc"
    }, [_c('dt', {
      staticClass: "title"
    }, [_vm._v(_vm._s(item.value))]), _vm._v(" "), _c('dd', {
      staticClass: "memo"
    }, [_vm._v(_vm._s(item.memo))]), _vm._v(" "), _c('dd', {
      staticClass: "contacts"
    }, [_vm._l((item.planUserArray), function(u, i) {
      return (i < 3) ? _c('span', {
        staticClass: "contact"
      }, [_c('img', {
        attrs: {
          "src": u.userAvatar,
          "alt": u.userName
        }
      }), _vm._v(" "), _c('span', {
        staticClass: "name"
      }, [_vm._v(_vm._s(u.userName))])]) : _vm._e()
    }), _vm._v(" "), (item.planUserArray.length > 3) ? _c('i', {
      staticClass: "el-icon-more"
    }) : _vm._e()], 2)])])
  })) : _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("暂无访客计划")]), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.dialogVisible = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), (_vm.isItem) ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.itemSave
    }
  }, [_vm._v("确定")]) : _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.setStatusByIds
    }
  }, [_vm._v("完成访客")])], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4930619e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modal/opportunity/customer-plan.vue
// module id = 1263
// module chunks = 82